import React, { Component } from 'react'
import '../styles/Dashboard.css'
import DropdownWidget from '../widgets/DropdownWidget'

class NetIncome extends Component
{
	constructor(props) {
		super(props)
		const date = new Date()
		this.state = {
			title: "NET INCOME",
			data: getLineChartData([
				Math.floor(Math.random()*10000000),
				Math.floor(Math.random()*10000000),
				Math.floor(Math.random()*10000000),
				Math.floor(Math.random()*10000000)
			], "quarterly", date.getFullYear()),
			xIntervals: 4
		}
		this.renderChart = this.renderChart.bind(this)
	}

	componentDidMount() {
		var lc = document.getElementById("net-income")
		this.setState({offsetHeight: lc.offsetHeight})
		window.addEventListener("resize", this.onResize.bind(this))
		this.renderChart()
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.onResize.bind(this))
	}

	onResize() {
		this.renderChart()
	}

	renderChart() {
		let width = window.innerWidth * 0.35
		const canvas = document.getElementById("ni-canvas")
		if(canvas == null) {
			return
		}
		canvas.width = window.innerWidth * 0.40
		canvas.height = window.innerHeight * 0.32
		const lineChart = new LineChart({
			canvas: canvas,
			xPadding: 60,
			yPadding: 22,
			xIntervals: this.state.xIntervals // this.props.xIntervals
		})
		// lineChart.draw(this.props.data)
		lineChart.draw(this.state.data)
	}

	render() {
		return(<div id="net-income">
			<div id="ni-header">
				<div id="ni-title">{this.state.title}</div>
				<div id="ni-filter">
					<div>FILTER BY:</div>
					<DropdownWidget list={[]} onItemSelected={(id, val) => {
					}} placeholder="ALL" cStyle={{"width": "210px"}} />
				</div>
			</div>
			<div class="ni-content"><canvas id="ni-canvas"/></div>
		</div>)
	}
}

const LineChart = function(props) {
	var {canvas, xPadding, yPadding} = props
	this.ctx = props.canvas.getContext("2d")
	this.draw = (data) => {
		const interval = (canvas.width / props.xIntervals) * 0.3
		this.ctx.lineWidth = 3
		this.ctx.strokeStyle = '#d33860'
		this.ctx.textAlign = "center"
		// Draw the axises
		this.ctx.beginPath()
		// this.ctx.moveTo(xPadding, yPadding)
		this.ctx.moveTo(xPadding, 0)
		this.ctx.lineTo(xPadding, canvas.height - yPadding)
		this.ctx.lineTo(canvas.width, canvas.height - yPadding)
		this.ctx.stroke()
		// Draw the X value texts
		this.ctx.font = '8pt roboto'
		for(var i = 0; i < data.values.length; i++) {
			console.log(data.values[i])
			this.ctx.fillText(data.values[i].X, getXPixel(i, canvas.width, xPadding, data.values)+interval, canvas.height - yPadding + 20)
		}
		// Draw the Y value texts
		this.ctx.textAlign = "center"
		this.ctx.textBaseline = "middle"
		const maxY = getMaxY(data.values)
		var yInterval = Math.round(maxY / 6)
		this.ctx.lineWidth = 1
		this.ctx.strokeStyle = '#fccc61'
		for(var i=0; i <= maxY; i+=yInterval) {
			const strVal = i.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
			const strWidth = this.ctx.measureText(strVal)
			this.ctx.fillText(strVal, xPadding-(strWidth.width*0.5)-5, getYPixel(i, canvas.height-20, yPadding, data.values)+20)
			this.ctx.beginPath()
			this.ctx.moveTo(xPadding, getYPixel(i, canvas.height-20, yPadding, data.values)+20)
			this.ctx.lineTo(canvas.width, getYPixel(i, canvas.height-20, yPadding, data.values)+20)
			this.ctx.stroke()
		}
		// Draw the line graph
		this.ctx.lineWidth = 3
		this.ctx.beginPath()
		this.ctx.strokeStyle = '#fccc61'
		this.ctx.moveTo(xPadding, canvas.height-20)
		this.ctx.lineTo(getXPixel(0, canvas.width, xPadding, data.values)+interval, getYPixel(data.values[0].Y, canvas.height-20, yPadding, data.values)+20)
		for(var i = 1; i < data.values.length; i ++) {
			this.ctx.lineTo(getXPixel(i, canvas.width, xPadding, data.values)+interval, getYPixel(data.values[i].Y, canvas.height-20, yPadding, data.values)+20)
		}
		this.ctx.stroke()
		// Draw the dots
		for(var i = 0; i < data.values.length; i ++) {
			this.ctx.beginPath()
			this.ctx.arc(getXPixel(i, canvas.width, xPadding, data.values)+interval, getYPixel(data.values[i].Y, canvas.height-20, yPadding, data.values)+20, 3, 0, Math.PI * 2, true)
			this.ctx.fillStyle = '#fccc61'
			this.ctx.fill()
			// this.ctx.fillStyle = '#A0283A'
			this.ctx.stroke()
		}
	}
}

const getMaxY = (values) => {
	console.log("values", values)
	var max = 0
	if(values == null) {
		return(0)
	}
	for(var i = 0; i < values.length; i++) {
		if(values[i].Y > max) {
			max = values[i].Y
		}
	}
	return max
}

const getXPixel = (val, width, xPadding, values) => {
	return((width - xPadding) / values.length) * val + (xPadding * 1.5)
}

const getYPixel = (val, height, yPadding, values) => {
	console.log("getYPixel", val, height, yPadding, values)
	return(height - (((height - yPadding) / getMaxY(values)) * val) - yPadding)
	// return(height - (((height) / getMaxY(values)) * val) - yPadding)
}

const getAbsentGranteesData = async (sid, uid, filter) => {
	try {
		const response = await fetch('/api/dashboard/absentgrantees', {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify({'filter': filter, 'sid': sid, 'user_id': uid})
		})
		if(!response.statusText) {
			throw Error(response.statusText)
		}
		const body = await response.json()
		return(body)
	}
	catch(error) {
		console.log(error)
		return(null)
	}
}

const getLineChartData = (raw, term, year) => {
	let data = {values: [], year: year}
	var xValues = getXValues(term)
	if(raw != null) {
		for(const i in xValues) {
			// data['values'].push({X: xValues[i], Y: raw[i].absent})
			data['values'].push({X: xValues[i], Y: raw[i]})
		}
	}
	else {
		for(const i in xValues) {
			data['values'].push({X: xValues[i], Y: 0})
		}
	}
	return(data)
}

const getXValues = (term) => {
	let values
	switch(term) {
		case "monthly":
			values = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
			break
		case "period":
			values = ["P1", "P2", "P3", "P4", "P5", "P6"]
			break
		case "quarterly":
			values = ["1STQ", "2NDQ", "3RDQ", "4THQ"]
			break
		case "semestral":
			values = ["1st Sem", "2nd Sem"]
			break
		case "yearly":
			values = ["1st Sem", "2nd Sem"]
			break
	}
	return(values)
}

const getXIntervals = (term) => {
	let v
	switch(term) {
		case "monthly":
			v = 12
			break
		case "period":
			v = 6
			break
		case "quarterly":
			v = 4
			break
		case "semestral":
			v = 2
			break
		case "yearly":
			v = 5
			break
	}
	return(v)
}

const thousandSeparators = (n) => {
	let numParts = n.toString().split('.')
	numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
	return(numParts.join("."))
}

export default NetIncome

